import { render, staticRenderFns } from "./JirutoNotification.vue?vue&type=template&id=cf1a1494&scoped=true&"
import script from "./JirutoNotification.vue?vue&type=script&lang=js&"
export * from "./JirutoNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf1a1494",
  null
  
)

export default component.exports